// @ts-strict-ignore
import { ApiUser } from 'api/types/ApiUserEnvironment';
import { getJson, postJson } from 'utils/http';

export type Invite = {
  id: string;
  email: string;
  byUser: {
    id: string;
    name: string;
  };
  hooks: Array<{
    hookType: string;
    organization?: {
      id: string;
      name: string;
    };
  }>;
};

export function fetchInvite(inviteId: string): Promise<Invite> {
  return getJson(`/data/website/invites/${inviteId}`).then(
    ({ invite }) => invite
  );
}

export function acceptInvite(inviteId: string): Promise<ApiUser> {
  return postJson(`/data/website/invites/${inviteId}`).then(({ user }) => user);
}
